export default (context) => {
  if (process.server) {
  }
}
